import { GetStaticPaths, GetStaticProps } from 'next';

import { InfoPageDetail } from '@components/infoPageDetail/InfoPageDetail';
import { Seo } from '@components/seo/Seo';

import { handleError } from '@common/utils/handleError';
import { staticWithSiteData, withErrorHandling } from '@common/utils/page';
import { queryFromDato } from '@data/datocms/client';
import { allInfoPagesQuery, infoPageQuery } from '@data/datocms/queries';
import { AllInfoPagesResponse, InfoPageResponse, SiteData } from '@interfaces';

type PageProps = InfoPageResponse;

const Page = ({
	infoPage,
	site: { faviconMetaTags },
}: PageProps & SiteData) => {
	return (
		<>
			<Seo metaTagData={[...infoPage.seoMetaTags, ...faviconMetaTags]} />
			<InfoPageDetail {...infoPage} />
		</>
	);
};

export const getStaticPaths: GetStaticPaths = async () => {
	let paths: Array<{ params: { slug: string } }> = [];

	try {
		const allInfoPagesResponse = await queryFromDato<AllInfoPagesResponse>({
			query: allInfoPagesQuery,
		});

		const allInfoPages = allInfoPagesResponse?.allInfoPages;

		if (allInfoPages) {
			paths = allInfoPages.map(({ slug }) => ({
				params: { slug },
			}));
		}
	} catch (error) {
		handleError(error);
	}

	return {
		paths,
		fallback: false,
	};
};

export const getStaticProps: GetStaticProps = withErrorHandling(
	staticWithSiteData<PageProps>(async ({ params }) => {
		const slug = String(params?.slug);
		const infoPageResponse = await queryFromDato<InfoPageResponse>({
			query: infoPageQuery,
			variables: { slug },
		});

		const infoPage = infoPageResponse?.infoPage;

		if (!infoPage) {
			return {
				notFound: true,
			};
		}

		return {
			props: {
				infoPage,
			},
		};
	}),
);

export default Page;
